(function () {
  if (window.__P2P_STYLIZE_BOUND__) return;
  window.__P2P_STYLIZE_BOUND__ = true;

  function init() {
    const root = document.querySelector('.p2p-stylize');
    if (!root) return;

    function getSearchParams() {
      try {
        return new URLSearchParams(window.location.search || '');
      } catch (_) {
        return new URLSearchParams();
      }
    }

    function hasDataEntryFlag() {
      return getSearchParams().get('data') === 'true';
    }

    function redirectToStep1() {
      const redirectUrl = root.dataset.step1RedirectUrl || 'https://prompt2prints.com/pages/photo-to-canvas';
      window.location.replace(redirectUrl);
    }

    if (!hasDataEntryFlag()) {
      redirectToStep1();
      return;
    }

    const continueUrl = root.dataset.continueUrl || 'https://prompt2prints.com/products/canvas?syncMode=pdp-img&data=true';
    const uploadedImageKey = root.dataset.uploadedImageKey || 'pdpUploadedImage';
    const originalImageKey = root.dataset.originalImageKey || 'pdpOriginalImage';
    const stylizedImageKey = root.dataset.stylizedImageKey || 'pdpStylizedImage';
    const selectedStyleKey = root.dataset.selectedStyleKey || 'p2p_selected_style';

    const imgOriginal = root.querySelector('#imgOriginal');
    const imgStyled = root.querySelector('#imgStyled');
    const styledWrap = root.querySelector('#styledWrap');
    const splitHandle = root.querySelector('#splitHandle');
    const splitWrap = root.querySelector('#splitWrap');
    const zoomStage = root.querySelector('#zoomStage');
    const zoomResetBtn = root.querySelector('#zoomResetBtn');
    const labelBefore = root.querySelector('#labelBefore');
    const previewHint = root.querySelector('.p2p-stylize__preview-hint');
    const styleGrid = root.querySelector('#styleGrid');
    const ctaBtn = root.querySelector('#ctaBtn');
    const ctaArea = root.querySelector('.p2p-stylize__cta-area');
    const ctaActions = root.querySelector('.p2p-stylize__cta-actions');
    const continueWrap = root.querySelector('#continueWrap');
    const continueBtn = root.querySelector('#continueBtn');
    const labelAfter = root.querySelector('#labelAfter');
    const selectedInfo = root.querySelector('#selectedInfo');
    const selInfoName = root.querySelector('#selInfoName');
    const tweaksPanel = root.querySelector('.p2p-stylize__tweaks');
    const tweaksClose = root.querySelector('.p2p-stylize__tweaks-close');
    const defaultAfterLabel = labelAfter ? labelAfter.textContent : 'Stylized';
    const applyLabel = ctaBtn ? (ctaBtn.dataset.applyLabel || 'Apply Style') : 'Apply Style';
    const updateLabel = ctaBtn ? (ctaBtn.dataset.updateLabel || 'Update Style') : 'Update Style';

    const loadingOverlay = document.createElement('div');
    loadingOverlay.className = 'p2p-stylize__preview-overlay';
    loadingOverlay.hidden = true;
    loadingOverlay.innerHTML = `
    <div class="aipr-tab-loader-spinner"></div>
      <span class="p2p-stylize__preview-overlay-text">Applying style...</span>
    `;
    splitWrap.appendChild(loadingOverlay);

    const loadingOverlayText = loadingOverlay.querySelector('.p2p-stylize__preview-overlay-text');

    const styleDataEls = root.querySelectorAll('.p2p-stylize__style-data');
    const styles = Array.from(styleDataEls).map(el => ({
      id: el.dataset.id,
      name: el.dataset.name,
      cat: el.dataset.cat,
      img: el.dataset.img,
      filter: el.dataset.filter
    })).filter(style => style.id && style.name);

    styles.unshift({ id: 'none', name: 'No Style', cat: '', img: '', filter: '' });

    let selectedId = null;
    let isProcessing = false;
    let dragging = false;
    let originalPreviewUrl = '';
    let hasStyledResult = false;
    let appliedStyleId = null;
    let pendingPreviewLoads = 0;
    let comparisonReady = false;

    // ── PINCH-ZOOM (mobile) ──────────────────────────────────────
    const ZOOM_MIN = 1;
    const ZOOM_MAX = 3;
    let zoomScale = 1;
    let zoomTranslateX = 0;
    let zoomTranslateY = 0;
    let isZoomedIn = false;
    let zoomViewMode = null;
    let isPinching = false;
    let isPanning = false;
    let pinchStartDist = 0;
    let pinchStartScale = 1;
    let panStartX = 0;
    let panStartY = 0;
    let panStartTranslateX = 0;
    let panStartTranslateY = 0;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function getTouchDistance(t1, t2) {
      const dx = t2.clientX - t1.clientX;
      const dy = t2.clientY - t1.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function updateHandleVisibility() {
      if (!splitHandle) return;
      splitHandle.hidden = !comparisonReady || isZoomedIn;
    }

    function enterZoomView() {
      // Once a styled "after" result exists, zoom should isolate and magnify
      // only the after image — the before image is hidden and the slider's
      // clip-path is lifted so the full after image is visible while zoomed.
      zoomViewMode = comparisonReady ? 'after' : 'before';
      if (zoomViewMode === 'after') {
        if (imgOriginal) setImageVisible(imgOriginal, false);
        if (styledWrap) styledWrap.style.clipPath = 'inset(0 0 0 0%)';
        if (labelBefore) labelBefore.hidden = true;
      } else if (labelAfter) {
        labelAfter.hidden = true;
      }
    }

    function exitZoomView() {
      if (zoomViewMode === 'after') {
        if (imgOriginal) setImageVisible(imgOriginal, true);
        if (styledWrap) setSlider(getCurrentSliderPercent());
      }
      if (labelBefore) labelBefore.hidden = false;
      if (labelAfter) labelAfter.hidden = !comparisonReady;
      zoomViewMode = null;
    }

    function setZoomedState(zoomed) {
      const next = !!zoomed;
      if (next !== isZoomedIn) {
        isZoomedIn = next;
        if (isZoomedIn) {
          enterZoomView();
        } else {
          exitZoomView();
        }
      }
      if (splitWrap) splitWrap.classList.toggle('is-zoomed', isZoomedIn);
      updateHandleVisibility();
      if (zoomResetBtn) zoomResetBtn.hidden = !isZoomedIn;
    }

    function applyZoomTransform() {
      if (!zoomStage) return;
      zoomStage.style.transform = `translate(${zoomTranslateX}px, ${zoomTranslateY}px) scale(${zoomScale})`;
    }

    function clampPan() {
      if (!splitWrap) return;
      const rect = splitWrap.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const maxOffsetX = (rect.width * (zoomScale - 1)) / 2;
      const maxOffsetY = (rect.height * (zoomScale - 1)) / 2;
      zoomTranslateX = clamp(zoomTranslateX, -maxOffsetX, maxOffsetX);
      zoomTranslateY = clamp(zoomTranslateY, -maxOffsetY, maxOffsetY);
    }

    function resetZoom(animate) {
      zoomScale = 1;
      zoomTranslateX = 0;
      zoomTranslateY = 0;
      isPinching = false;
      isPanning = false;

      if (zoomStage) {
        if (animate) {
          zoomStage.classList.add('is-zoom-animating');
          window.setTimeout(() => {
            if (zoomStage) zoomStage.classList.remove('is-zoom-animating');
          }, 250);
        }
        zoomStage.style.transform = '';
      }

      setZoomedState(false);
    }
    // ─────────────────────────────────────────────────────────────

    function triggerNoCreditsPopup() {
      try {
        if (typeof showNoCreditPopup === 'function') {
          showNoCreditPopup();
          return;
        }
      } catch (_) {}

      try {
        if (window && typeof window.showNoCreditPopup === 'function') {
          window.showNoCreditPopup();
        }
      } catch (_) {}
    }

    function hasNoMoreCredits(payload) {
      if (!payload) return false;

      if (typeof payload === 'object' && payload.error && typeof payload.error === 'string') {
        try {
          if (payload.error.toLowerCase().includes('no more credits')) {
            return true;
          }
        } catch (_) {}
      }

      let message = '';
      if (typeof payload === 'string') {
        message = payload;
      } else if (typeof payload === 'object') {
        message =
          (typeof payload.error === 'string' && payload.error) ||
          (typeof payload.message === 'string' && payload.message) ||
          (typeof payload.detail === 'string' && payload.detail) ||
          '';
      }

      return !!(message && message.toLowerCase().includes('no more credits'));
    }

    function setPreviewOverlay(isVisible, text) {
      if (!loadingOverlay) return;
      if (loadingOverlayText && typeof text === 'string') {
        loadingOverlayText.textContent = text;
      }
      loadingOverlay.hidden = !isVisible;
    }

    function beginPreviewLoad(text) {
      pendingPreviewLoads += 1;
      setPreviewOverlay(true, text || 'Loading preview...');
    }

    function endPreviewLoad() {
      pendingPreviewLoads = Math.max(0, pendingPreviewLoads - 1);
      if (pendingPreviewLoads === 0 && !isProcessing) {
        setPreviewOverlay(false);
      }
    }

    function waitForImage(imgEl) {
      return new Promise(resolve => {
        if (!imgEl) return resolve();
        const src = imgEl.getAttribute('src') || imgEl.src || '';
        if (!src) return resolve();

        if (imgEl.complete && imgEl.naturalWidth > 0) {
          return resolve();
        }

        const done = () => resolve();
        imgEl.addEventListener('load', done, { once: true });
        imgEl.addEventListener('error', done, { once: true });
      });
    }

    function setImageVisible(imgEl, isVisible) {
      if (!imgEl) return;
      if (isVisible) {
        imgEl.style.opacity = '';
        imgEl.style.visibility = '';
      } else {
        imgEl.style.opacity = '0';
        imgEl.style.visibility = 'hidden';
      }
    }

    function applyPreviewPlaceholderSizing() {
      if (!splitWrap) return;

      const w = splitWrap.clientWidth || root.clientWidth || window.innerWidth || 0;
      if (!w) return;

      /* Reserve space for the preview before images load (responsive, clamped). */
      const ratio = 4 / 3; /* width:height */
      const minH = Math.max(240, Math.min(520, Math.round(w / ratio)));

      splitWrap.style.maxHeight = 50 + 'svh';
      if (imgOriginal) imgOriginal.style.maxHeight = 50 + 'svh';
      if (imgStyled) imgStyled.style.maxHeight = 50 + 'svh';
    }

    function scrollPreviewToTop() {
      const target = root.querySelector('.p2p-stylize__preview') || splitWrap || root;
      try {
        const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const behavior = prefersReducedMotion ? 'auto' : 'smooth';
        const offset = 103;
        const top = Math.max(0, window.pageYOffset + target.getBoundingClientRect().top - offset);
        window.scrollTo({ top, left: 0, behavior });
      } catch (_) {
        try { window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); } catch (_) {}
        try { window.scrollTo(0, 0); } catch (_) {}
      }
    }

    function getCookie(name) {
      if (!name || !document.cookie) return null;

      for (const part of document.cookie.split('; ')) {
        const idx = part.indexOf('=');
        if (idx === -1) continue;
        if (part.slice(0, idx) !== name) continue;

        try {
          return decodeURIComponent(part.slice(idx + 1));
        } catch (_) {
          return part.slice(idx + 1);
        }
      }

      return null;
    }

    function setCookie(name, value, maxAge) {
      const parts = [
        name + '=' + encodeURIComponent(value || ''),
        'path=/',
        'max-age=' + maxAge,
        'SameSite=Lax'
      ];

      if (/(^|\.)prompt2prints\.com$/i.test(window.location.hostname)) {
        parts.push('domain=.prompt2prints.com');
      }

      if (window.location.protocol === 'https:') {
        parts.push('Secure');
      }

      document.cookie = parts.join('; ');
    }

    function getStoredValue(keys) {
      for (const key of keys) {
        if (!key) continue;

        try {
          const storageValue = localStorage.getItem(key);
          if (storageValue) return storageValue;
        } catch (_) {}

        const cookieValue = getCookie(key);
        if (cookieValue) return cookieValue;
      }

      return null;
    }

    function persistImage(keys, value) {
      if (!value) return;

      const oneDay = 24 * 60 * 60;
      const uniqueKeys = Array.from(new Set(keys.filter(Boolean)));

      uniqueKeys.forEach(key => {
        try { localStorage.setItem(key, value); } catch (_) {}
        setCookie(key, value, oneDay);
      });
    }

    function persistOriginalImage(url) {
      persistImage([
        originalImageKey,
        'pdpOriginalImage',
        'p2pOriginalImage'
      ], url);
    }

    function persistStylizedImage(url) {
      persistImage([
        stylizedImageKey,
        'pdpStylizedImage',
        uploadedImageKey,
        'pdpUploadedImage',
        'p2pUploadedImage'
      ], url);
    }

    function getApiConfig() {
      const p2p = window.Prompt2Prints || {};
      return {
        base: p2p.apiBase || 'https://api.prompt2prints.com',
        apiKey: p2p.apiKey || ''
      };
    }

    function getCustomerId() {
      return root.dataset.customerId || window.shopifyCustomerId || 'guest';
    }

    function getSessionId() {
      try {
        return localStorage.getItem('sessionId') || 'none';
      } catch (_) {
        return 'none';
      }
    }

    function getArrowIconMarkup() {
      return `
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M5 12h14"/><path d="M12 5l7 7-7 7"/>
        </svg>
      `;
    }

    function getSpinnerIconMarkup() {
      return `
        <svg class="p2p-stylize__cta-spinner" width="18" height="18" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2.5"
          stroke-linecap="round" aria-hidden="true">
          <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83
                   M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
        </svg>
      `;
    }

    function setPrimaryButtonLabel(label) {
      if (!ctaBtn) return;
      ctaBtn.innerHTML = `${label} ${getArrowIconMarkup()}`;
    }

    function setContinueVisibility(isVisible, isDisabled) {
      if (continueWrap) continueWrap.hidden = !isVisible;
      if (continueBtn) {
        const shouldDisable = !isVisible || !!isDisabled;
        continueBtn.disabled = shouldDisable;
        continueBtn.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
      }
    }

    function syncActionButtons() {
      if (!ctaBtn) return;

      const alreadyApplied = hasStyledResult && (selectedId === appliedStyleId);
      const canSubmit = !!selectedId && !isProcessing && !alreadyApplied;
      const canContinue = hasStyledResult;

      ctaBtn.disabled = !canSubmit;
      ctaBtn.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
      ctaBtn.classList.toggle('is-ready', canSubmit);
      ctaBtn.classList.toggle('is-secondary', hasStyledResult);
      if (ctaArea) ctaArea.classList.toggle('has-styled-result', hasStyledResult);
      if (ctaActions) ctaActions.classList.toggle('has-two-actions', hasStyledResult);

      if (!ctaBtn.classList.contains('is-loading') && !ctaBtn.classList.contains('is-error')) {
        setPrimaryButtonLabel(hasStyledResult ? updateLabel : applyLabel);
      }

      setContinueVisibility(canContinue, isProcessing);
    }

    function setComparisonReady(isReady) {
      comparisonReady = !!isReady;
      splitWrap.classList.toggle('is-before-only', !isReady);
      splitWrap.classList.toggle('is-comparison-ready', !!isReady);

      updateHandleVisibility();
      if (labelAfter) labelAfter.hidden = !isReady;
      if (previewHint) previewHint.hidden = !isReady;
    }

    function setSlider(pct) {
      const clamped = Math.max(0, Math.min(100, pct));
      splitHandle.style.left = clamped + '%';
      styledWrap.style.clipPath = `inset(0 0 0 ${clamped}%)`;
    }

    function getCurrentSliderPercent() {
      if (!splitHandle) return 50;

      const current = parseFloat(splitHandle.style.left);
      return Number.isFinite(current) ? current : 50;
    }

    function hasAppliedPreview() {
      return !!(
        hasStyledResult &&
        imgStyled &&
        (imgStyled.getAttribute('src') || imgStyled.src) &&
        splitWrap.classList.contains('is-comparison-ready')
      );
    }

    function animateSlider(from, to, duration) {
      const start = performance.now();

      function tick(now) {
        const t = Math.min(1, (now - start) / duration);
        const ease = 1 - Math.pow(1 - t, 3);
        setSlider(from + (to - from) * ease);
        if (t < 1) requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    }

    function canDragSlider() {
      return !isProcessing && splitWrap.classList.contains('is-comparison-ready') && !isZoomedIn;
    }

    function resetStyledPreview() {
      resetZoom(false);
      imgStyled.style.filter = '';
      imgStyled.classList.remove('is-loading', 'is-ready');
      imgStyled.removeAttribute('src');
      setComparisonReady(false);
      setSlider(100);
    }

    function renderGrid() {
      styleGrid.innerHTML = '';

      styles.forEach(style => {
        const card = document.createElement('div');
        card.className = 'p2p-stylize__card' + (style.id === selectedId ? ' is-selected' : '');
        card.dataset.id = style.id;
        if (style.id === 'none') {
          card.classList.add('p2p-stylize__card--none');
          card.innerHTML = `
            <img class="p2p-stylize__card-none-img" src="https://cdn.shopify.com/s/files/1/0926/7786/5836/files/none.png?v=1778146745" alt="${style.name}" loading="lazy">
            <div class="p2p-stylize__card-label">${style.name}</div>
            <div class="p2p-stylize__card-check" aria-hidden="true">&#x2713;</div>
          `;
        } else {
          card.innerHTML = `
            <img src="${style.img}" alt="${style.name}" loading="lazy">
            <div class="p2p-stylize__card-label">${style.name}</div>
            <div class="p2p-stylize__card-check" aria-hidden="true">&#x2713;</div>
          `;
        }
        card.addEventListener('click', () => {
          if (!isProcessing) selectStyle(style.id);
        });
        styleGrid.appendChild(card);
      });
    }

    function selectStyle(id) {
      const style = styles.find(entry => entry.id === id);
      if (!style) return;

      selectedId = id;

      styleGrid.querySelectorAll('.p2p-stylize__card').forEach(card => {
        card.classList.toggle('is-selected', card.dataset.id === id);
      });

      if (!hasAppliedPreview()) {
        resetStyledPreview();
      }

      if (labelAfter && !hasAppliedPreview()) {
        labelAfter.textContent = style.name || defaultAfterLabel;
      }
      if (selectedInfo) selectedInfo.hidden = false;
      if (selInfoName) selInfoName.textContent = style.name;

      ctaBtn.classList.remove('is-error', 'is-loading');
      syncActionButtons();

      try { localStorage.setItem(selectedStyleKey, id); } catch (_) {}
    }

    async function callStylizeApi(imageUrl, style) {
      const cfg = getApiConfig();
      if (!cfg.apiKey) throw new Error('Prompt2Prints API key is not configured.');

      const res = await fetch(cfg.base + '/stylize-image-with-nano', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': cfg.apiKey
        },
        body: JSON.stringify({
          imageUrl,
          style: style.id,
          styleName: style.name,
          customerId: getCustomerId(),
          sessionId: getSessionId()
        })
      });

      if (!res.ok) {
        let errPayload = null;
        try {
          const contentType = (res.headers.get('content-type') || '').toLowerCase();
          if (contentType.includes('application/json')) {
            errPayload = await res.json();
          } else {
            errPayload = await res.text();
          }
        } catch (_) {
          try {
            errPayload = await res.text();
          } catch (_) {
            errPayload = String(res.status);
          }
        }

        if (errPayload && typeof errPayload === 'object' && errPayload.error && typeof errPayload.error === 'string') {
          try {
            if (errPayload.error.toLowerCase().includes('no more credits')) {
              triggerNoCreditsPopup();
            }
          } catch (_) {}
        }
        if (hasNoMoreCredits(errPayload)) {
          triggerNoCreditsPopup();
        }

        const errText = typeof errPayload === 'string' ? errPayload : JSON.stringify(errPayload);
        throw new Error('API ' + res.status + ': ' + errText);
      }

      const data = await res.json();
      if (data && data.error && typeof data.error === 'string') {
        if (data.error.toLowerCase().includes('no more credits')) {
          triggerNoCreditsPopup();
        }
      }
        fetchCredits();
      return data;
    }

    (function loadOriginalPreview() {
      /* Prevent flashing the initial <img src="..."> before we control the load. */
      const initialOriginalSrc = imgOriginal ? (imgOriginal.getAttribute('src') || imgOriginal.src || '') : '';
      if (imgOriginal) {
        setImageVisible(imgOriginal, false);
        try { imgOriginal.removeAttribute('src'); } catch (_) {}
      }
      if (imgStyled) {
        setImageVisible(imgStyled, false);
      }
      applyPreviewPlaceholderSizing();

      const storedOriginalUrl = getStoredValue([
        originalImageKey,
        'pdpOriginalImage',
        'p2pOriginalImage',
        uploadedImageKey,
        'pdpUploadedImage',
        'p2pUploadedImage',
        'p2p_uploaded_image'
      ]);
      const fallbackOriginalUrl = initialOriginalSrc;

      originalPreviewUrl = storedOriginalUrl || fallbackOriginalUrl;

      if (storedOriginalUrl) {
        persistOriginalImage(storedOriginalUrl);
      }

      if (originalPreviewUrl && imgOriginal) {
        beginPreviewLoad('Loading preview...');
        imgOriginal.src = originalPreviewUrl;
        waitForImage(imgOriginal).then(() => {
          setImageVisible(imgOriginal, true);
          endPreviewLoad();
        });
      }
      resetStyledPreview();
    })();

      fetchCredits();
    applyPreviewPlaceholderSizing();
    window.addEventListener('resize', applyPreviewPlaceholderSizing);

    setSlider(100);

    splitWrap.addEventListener('mousedown', event => {
      if (!canDragSlider()) return;
      dragging = true;
      updateSlider(event);
    });

    document.addEventListener('mousemove', event => {
      if (dragging) updateSlider(event);
    });

    document.addEventListener('mouseup', () => {
      dragging = false;
    });

    function startPan(touch) {
      isPanning = true;
      panStartX = touch.clientX;
      panStartY = touch.clientY;
      panStartTranslateX = zoomTranslateX;
      panStartTranslateY = zoomTranslateY;
    }

    zoomResetBtn && zoomResetBtn.addEventListener('click', () => {
      resetZoom(true);
    });

    splitWrap.addEventListener('touchstart', event => {
      if (zoomResetBtn && (event.target === zoomResetBtn || zoomResetBtn.contains(event.target))) {
        return;
      }

      if (event.touches.length >= 2) {
        isPinching = true;
        isPanning = false;
        dragging = false;
        pinchStartDist = getTouchDistance(event.touches[0], event.touches[1]);
        pinchStartScale = zoomScale;
        // Switch to zoom view the instant a pinch begins so the label swap and
        // handle hide happen immediately, instead of flickering in/out while
        // the live scale hovers near the zoomed-in threshold mid-gesture.
        setZoomedState(true);
        event.preventDefault();
        return;
      }

      if (isZoomedIn) {
        startPan(event.touches[0]);
        event.preventDefault();
        return;
      }

      if (!canDragSlider()) return;
      dragging = true;
      updateSlider(event.touches[0]);
    }, { passive: false });

    document.addEventListener('touchmove', event => {
      if (isPinching && event.touches.length >= 2) {
        const dist = getTouchDistance(event.touches[0], event.touches[1]);
        if (pinchStartDist > 0) {
          zoomScale = clamp(pinchStartScale * (dist / pinchStartDist), ZOOM_MIN, ZOOM_MAX);
          clampPan();
          applyZoomTransform();
        }
        event.preventDefault();
        return;
      }

      if (isPanning && event.touches.length === 1 && isZoomedIn) {
        const touch = event.touches[0];
        zoomTranslateX = panStartTranslateX + (touch.clientX - panStartX);
        zoomTranslateY = panStartTranslateY + (touch.clientY - panStartY);
        clampPan();
        applyZoomTransform();
        event.preventDefault();
        return;
      }

      if (dragging) updateSlider(event.touches[0]);
    }, { passive: false });

    function endTouchInteractions(event) {
      const remaining = event && event.touches ? event.touches.length : 0;

      if (isPinching && remaining < 2) {
        isPinching = false;
        if (zoomScale <= 1.02) {
          resetZoom(true);
        } else if (remaining === 1) {
          startPan(event.touches[0]);
        }
      }

      if (isPanning && remaining === 0) {
        isPanning = false;
        if (zoomScale <= 1.02) resetZoom(true);
      }

      dragging = false;
    }

    document.addEventListener('touchend', endTouchInteractions);
    document.addEventListener('touchcancel', endTouchInteractions);

    function updateSlider(event) {
      if (!canDragSlider()) return;

      const rect = splitWrap.getBoundingClientRect();
      const nextPercent = ((event.clientX - rect.left) / rect.width) * 100;
      setSlider(nextPercent);
    }

    (function restoreSelection() {
      try {
        const saved = localStorage.getItem(selectedStyleKey);
        if (!saved) return;

        const slug = saved.toLowerCase().replace(/[^a-z0-9]+/g, '');
        const match = styles.find(style =>
          style.id === saved ||
          style.id.toLowerCase().replace(/[^a-z0-9]+/g, '') === slug ||
          style.name.toLowerCase().replace(/[^a-z0-9]+/g, '') === slug
        );

        if (match) selectStyle(match.id);
      } catch (_) {}
    })();

    ctaBtn.addEventListener('click', async function () {
      if (!selectedId || ctaBtn.disabled || isProcessing) return;

      const style = styles.find(entry => entry.id === selectedId);
      if (!style) return;

      const sourceUrl = originalPreviewUrl || imgOriginal.src;
      if (!sourceUrl) return;

      scrollPreviewToTop();

      const hadAppliedPreview = hasAppliedPreview();
      const previousSliderPercent = getCurrentSliderPercent();

      isProcessing = true;
      dragging = false;
      if (!hadAppliedPreview) {
        resetStyledPreview();
      }
      setContinueVisibility(hasStyledResult, true);

      ctaBtn.disabled = true;
      ctaBtn.classList.add('is-loading');
      ctaBtn.classList.remove('is-error', 'is-ready');
      ctaBtn.innerHTML = `${getSpinnerIconMarkup()} Applying style...`;

      imgStyled.classList.remove('is-ready');
      imgStyled.classList.add('is-loading');
      if (loadingOverlayText) {
        loadingOverlayText.textContent = style.name
          ? `Applying ${style.name} style...`
          : 'Applying style...';
      }
      setPreviewOverlay(true);

      if (style.id === 'none') {
        const noneUrl = originalPreviewUrl || (imgOriginal && imgOriginal.src) || '';
        setImageVisible(imgStyled, false);
        imgStyled.classList.remove('is-ready');
        imgStyled.src = noneUrl;
        await waitForImage(imgStyled);
        setImageVisible(imgOriginal, true);
        setImageVisible(imgStyled, true);
        setPreviewOverlay(false);
        imgStyled.classList.remove('is-loading');
        imgStyled.classList.add('is-ready');
        hasStyledResult = true;
        appliedStyleId = 'none';
        if (labelAfter) labelAfter.textContent = 'Original';
        setComparisonReady(true);
        if (hadAppliedPreview) {
          setSlider(previousSliderPercent);
        } else {
          animateSlider(100, 50, 700);
        }
        persistStylizedImage(noneUrl);
        try { localStorage.setItem(selectedStyleKey, 'none'); } catch (_) {}
        ctaBtn.classList.remove('is-loading');
        isProcessing = false;
        syncActionButtons();
        return;
      }

      try {
        const result = await callStylizeApi(sourceUrl, style);
        const originalUrl = result && result.original ? result.original : sourceUrl;
        const stylizedUrl = result && result.styled ? result.styled : '';

        if (stylizedUrl) {
          await new Promise((resolve, reject) => {
            const previewImage = new Image();
            previewImage.onload = resolve;
            previewImage.onerror = reject;
            previewImage.src = stylizedUrl;
          });

          originalPreviewUrl = originalUrl;
          persistOriginalImage(originalUrl);
          let loadsStarted = 0;
          if (imgOriginal) {
            beginPreviewLoad('Loading preview...');
            loadsStarted += 1;
            setImageVisible(imgOriginal, false);
            imgOriginal.src = originalUrl;
          }

          imgStyled.style.filter = '';
          beginPreviewLoad('Loading preview...');
          loadsStarted += 1;
          setImageVisible(imgStyled, false);
          imgStyled.src = stylizedUrl;
          await Promise.all([waitForImage(imgOriginal), waitForImage(imgStyled)]);
          setImageVisible(imgOriginal, true);
          setImageVisible(imgStyled, true);
          while (loadsStarted > 0) {
            endPreviewLoad();
            loadsStarted -= 1;
          }
          setPreviewOverlay(false);
          imgStyled.classList.remove('is-loading');
          imgStyled.classList.add('is-ready');

          hasStyledResult = true;
          appliedStyleId = style.id;
          if (labelAfter) {
            labelAfter.textContent = style.name || defaultAfterLabel;
          }
          setComparisonReady(true);

          if (hadAppliedPreview) {
            setSlider(previousSliderPercent);
          } else {
            animateSlider(100, 50, 700);
          }

          persistStylizedImage(stylizedUrl);
        } else {
          imgStyled.classList.remove('is-loading');
          if (hadAppliedPreview) {
            imgStyled.classList.add('is-ready');
            setComparisonReady(true);
            setSlider(previousSliderPercent);
          } else {
            imgStyled.classList.remove('is-ready');
            imgStyled.removeAttribute('src');
          }
          setPreviewOverlay(false);
        }

        try { localStorage.setItem(selectedStyleKey, style.id); } catch (_) {}

        ctaBtn.classList.remove('is-loading');
        isProcessing = false;
        syncActionButtons();
      } catch (err) {
        console.error('[P2P Stylize] API error:', err);

        setPreviewOverlay(false);
        imgStyled.classList.remove('is-loading');

        if (hadAppliedPreview) {
          imgStyled.classList.add('is-ready');
          setComparisonReady(true);
          setSlider(previousSliderPercent);
        } else {
          resetStyledPreview();
        }

        ctaBtn.classList.remove('is-loading');
        ctaBtn.classList.add('is-error');
        ctaBtn.disabled = false;
        ctaBtn.innerHTML = `
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Something went wrong - try again
        `;

        try { localStorage.setItem(selectedStyleKey, style.id); } catch (_) {}
        try { localStorage.setItem('p2p_style_filter', style.filter || ''); } catch (_) {}

        isProcessing = false;
        setContinueVisibility(hasStyledResult, false);
      }
    });

    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        if (isProcessing || continueBtn.disabled) return;
        window.location.href = continueUrl;
      });
    }

    if (tweaksClose && tweaksPanel) {
      tweaksClose.addEventListener('click', () => {
        tweaksPanel.hidden = true;
        window.parent.postMessage({ type: '__edit_mode_dismissed' }, '*');
      });
    }

    root.querySelectorAll('.p2p-stylize__tweaks-btns [data-cols]').forEach(btn => {
      btn.addEventListener('click', () => {
        styleGrid.style.gridTemplateColumns = `repeat(${btn.dataset.cols}, 1fr)`;
        root.querySelectorAll('.p2p-stylize__tweaks-btns [data-cols]').forEach(button => {
          button.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });

    window.addEventListener('message', event => {
      if (!tweaksPanel) return;
      if (event.data && event.data.type === '__activate_edit_mode') tweaksPanel.hidden = false;
      if (event.data && event.data.type === '__deactivate_edit_mode') tweaksPanel.hidden = true;
    });

    window.parent.postMessage({ type: '__edit_mode_available' }, '*');

    renderGrid();
    syncActionButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
